import { UserHistoricalFormDataItem } from 'interfaces/components/savedUserData/UserHistoricalFormDataItem';
import { formatCalculationResult } from './calculateFunctions';

export const formatUserHistoricalFormData = (
  data: UserHistoricalFormDataItem
): UserHistoricalFormDataItem => {
  if (!data) return data;

  return {
    ...data,
    YOY_ARR_OR_REVENUE_GROWTH: formatCalculationResult(
      parseFloat(data.YOY_ARR_OR_REVENUE_GROWTH || ''),
      2,
      true
    ),
    GROSSCOMPOSITIONARR: formatCalculationResult(
      parseFloat(data.GROSSCOMPOSITIONARR || ''),
      2,
      true
    ),
    NEWLOGOVELOCITY: formatCalculationResult(
      parseFloat(data.NEWLOGOVELOCITY || ''),
      2,
      true
    ),
    QUICK_RATIO: formatCalculationResult(
      parseFloat(data.QUICK_RATIO || ''),
      2,
      true
    ),
    NET_DOLLAR_RETENTION: formatCalculationResult(
      parseFloat(data.NET_DOLLAR_RETENTION || ''),
      2,
      true
    ),
    GROSSDOLLARRETENTION: formatCalculationResult(
      parseFloat(data.GROSSDOLLARRETENTION || ''),
      2,
      true
    ),
    CURRENT_ARR_OR_ANNUALIZED_REVENUE: formatCalculationResult(
      parseFloat(data.CURRENT_ARR_OR_ANNUALIZED_REVENUE || ''),
      2,
      true
    ),
    REVENUE: formatCalculationResult(parseFloat(data.REVENUE || ''), 2, true),
    TOTAL_HEADCOUNT: formatCalculationResult(
      parseFloat(data.TOTAL_HEADCOUNT || ''),
      2,
      true
    ),
    NET_MAGIC_NUMBER: formatCalculationResult(
      parseFloat(data.NET_MAGIC_NUMBER || ''),
      2,
      true
    ),
    RULE_OF_40: formatCalculationResult(
      parseFloat(data.RULE_OF_40 || ''),
      2,
      true
    ),
    CACPAYBACK: formatCalculationResult(
      parseFloat(data.CACPAYBACK || ''),
      2,
      true
    ),
    BURN_MULTIPLE: formatCalculationResult(
      parseFloat(data.BURN_MULTIPLE || ''),
      2,
      true
    ),
    OPEX_FUNCTION_AS_A_PERCENTAGE_OF_REVENUE_G_AND_A: formatCalculationResult(
      parseFloat(data.OPEX_FUNCTION_AS_A_PERCENTAGE_OF_REVENUE_G_AND_A || ''),
      2,
      true
    ),
    OPEX_FUNCTION_AS_A_PERCENTAGE_OF_REVENUE_R_AND_D: formatCalculationResult(
      parseFloat(data.OPEX_FUNCTION_AS_A_PERCENTAGE_OF_REVENUE_R_AND_D || ''),
      2,
      true
    ),
    OPEX_FUNCTION_AS_A_PERCENTAGE_OF_REVENUE_S_AND_M: formatCalculationResult(
      parseFloat(data.OPEX_FUNCTION_AS_A_PERCENTAGE_OF_REVENUE_S_AND_M || ''),
      2,
      true
    ),
    GROSS_MARGIN: formatCalculationResult(
      parseFloat(data.GROSS_MARGIN || ''),
      2,
      true
    ),
    FCF_MARGIN: formatCalculationResult(
      parseFloat(data.FCF_MARGIN || ''),
      2,
      true
    ),
    HEADCOUNT_PER_G_AND_A: formatCalculationResult(
      parseFloat(data.HEADCOUNT_PER_G_AND_A || ''),
      2,
      true
    ),
    HEADCOUNT_PER_R_AND_D: formatCalculationResult(
      parseFloat(data.HEADCOUNT_PER_R_AND_D || ''),
      2,
      true
    ),
    HEADCOUNT_PER_S_AND_M: formatCalculationResult(
      parseFloat(data.HEADCOUNT_PER_S_AND_M || ''),
      2,
      true
    ),
    ARR_PER_FTE: formatCalculationResult(
      parseFloat(data.ARR_PER_FTE || ''),
      2,
      true
    ),
    OPEXPERFTE: formatCalculationResult(
      parseFloat(data.OPEXPERFTE || ''),
      2,
      true
    )
  };
};
